export default __webpack_public_path__ + "static/media/RosieLovelace.c8cd15eb.png";